$(document).ready(function() {
    $('.oauth-btn').on('click', function() {
        const provider = $(this).data('provider');

        $('#oauth-error').hide();
        $(this).prop('disabled', true);

        $.ajax({
            url: `/auth/${provider}/`,
            method: 'GET',
            success: function(response) {
                if (response.status === 'success') {
                    console.log(response);
                } else {
                    $('#oauth-error').show();
                    $('.oauth-btn').prop('disabled', false);
                }
            },
            error: function() {
                $('#oauth-error').show();
                $('.oauth-btn').prop('disabled', false);
            }
        });
    });
});